export default __webpack_public_path__ + "static/media/logo138x75black.c35229cf.png";